/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('stepIndex', [
  '$timeout',

  function ($timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./step-index.html'),

      replace: true,

      scope: {
        step: '=',
      },

      link(scope, element, attrs) {
        const $circleFill = element.find('.circleFill');
        const $stepHeaderIndex = element;

        const showIcon = function (show) {
          $stepHeaderIndex[show ? 'addClass' : 'removeClass']('show-icon');
        };

        const setValidStep = function (valid, withDealay) {
          if (withDealay && valid) {
            $timeout(function () {
              showIcon(valid);
            }, 500);
          } else {
            showIcon(valid);
          }

          $circleFill.attr('class', valid ? 'circleFill' : 'circleFill filled');
        };

        $timeout(function () {
          scope.$watch(
            'step',
            function (newStep, oldStep) {
              if (newStep.active !== oldStep.active) {
                // scope.$parent.$parent.setActive(scope.step.index, true);
              }

              if (newStep.valid !== oldStep.valid) {
                setValidStep(newStep.valid, true);
              }

              showIcon(newStep.lock || newStep.valid || newStep.error);
            },
            true,
          );

          if (scope.step.active) scope.$parent.$parent.setActive(scope.step.index, true);

          setValidStep(scope.step.valid);
        }, 1000);
      },
    };
  },
]);
